<header class="fixed-menu" *ngIf="!hideMenuInPaymentScreen() && !shoulHideMenu()" >
    <app-navbar></app-navbar>
</header>
<router-outlet></router-outlet>
<app-loader></app-loader>
<app-footer></app-footer>
